module.exports = __webpack_public_path__ + "img/apple_pie_baked.f64364f5.jpg";